import { supportEmail, discordInviteURL } from '../config'
import PageContainer from '../components/PageContainer'
import MetaDesc from '../components/MetaDesc'
import NewTabLink from '../components/NewTabLink'

const Contact = () => {
  return (
    <PageContainer>
      <MetaDesc>
        Contact the developer of Mastermine to suggest new features, ask for
        help, or report bugs.
      </MetaDesc>

      <h2>Contact me</h2>

      <p>
        If you're having issues with your copy of Mastermine, feel
        free to contact me at <a href={`mailto:${supportEmail}`}>{supportEmail}</a>
      </p>

      <p>
        If you're looking for tips, tricks & discussion about the game,
        maybe instead head over to our <NewTabLink href={discordInviteURL}>Discord server</NewTabLink>.
        There you can chat with world record holding players, live stream gameplay,
        and suggest new features for the game.
      </p>

      <p>
        Got a suggestion or bug report? Let me know by email or Discord, and
        your name will show up in the game's next update :) Please make sure
        you disclose serious issues, like those concerning solve times, via
        email or Discord personal message.
      </p>
    </PageContainer>
  )
}

export default Contact
